import { render, staticRenderFns } from "./TestResults.vue?vue&type=template&id=477e8bea&scoped=true&"
import script from "./TestResults.vue?vue&type=script&lang=ts&"
export * from "./TestResults.vue?vue&type=script&lang=ts&"
import style0 from "./TestResults.vue?vue&type=style&index=0&id=477e8bea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477e8bea",
  null
  
)

export default component.exports